import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
strong {
    font-family: 'Nimbus Sans Condensed Bold', 'Nimbus Sans Condensed',
        sans-serif;
}
.shared-tool-tip {
    background: #ffffff;
    padding: calc(24px / 2);
    width: -webkit-max-content;
    width: max-content;
    border: 1px solid #eeeeee;
    border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
    color: #000000;
}
.global-nav-tool-tip {
    background: #ebebeb;
    padding: 0;
    padding-left: calc(8px * 2);
    padding-right: calc(8px * 2);
    width: -webkit-max-content;
    width: max-content;
    border: 1px solid #eeeeee;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.tool-tip {
    background: #ffffff;
    padding: calc(24px / 2);
    width: -webkit-max-content;
    width: max-content;
    border: 1px solid #eeeeee;
    border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
    color: #000000;
    text-align: left;
}
.tool-tip-mobile {
    background: #ffffff;
    padding: calc(24px / 2);
    width: -webkit-max-content;
    width: max-content;
    border: 1px solid #eeeeee;
    border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
img {
    float: right;
}
@media (max-width: 720px) {
    .tool-tip-mobile {
        display: table-cell;
    }
}
`;

export default styles;